











import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "BaseChip",
  props: {
    small: { type: Boolean, default: false },
    primary: { type: Boolean, default: false },
    round: { type: Boolean, default: false },
    outlined: { type: Boolean, default: false },
    flat: { type: Boolean, default: false },
    height: { type: [Number, String], default: 38 },
  },
});
